// Domain constants/enums for the account-transaction resource (relocated from the legacy Model in wave 4.3 ahead of models/ deletion).

const _TRANSACTION_TYPE_VALUES = {
  PAYMENT: 'TransactionType.PAYMENT',
  INTEREST: 'TransactionType.INTEREST',
  AMBIGUOUS: 'TransactionType.AMBIGUOUS',
} as const;

export type AccountTransactionType =
  (typeof _TRANSACTION_TYPE_VALUES)[keyof typeof _TRANSACTION_TYPE_VALUES];

const _TRANSACTION_CATEGORY_VALUES = {
  DEBIT: 'TransactionCategory.DEBIT',
  CREDIT: 'TransactionCategory.CREDIT',
  AMBIGUOUS: 'TransactionCategory.AMBIGUOUS',
} as const;

export type AccountTransactionCategory =
  (typeof _TRANSACTION_CATEGORY_VALUES)[keyof typeof _TRANSACTION_CATEGORY_VALUES];

export const ACCOUNT_TRANSACTION_VERIFICATION_STATE = {
  PENDING_VERIFICATION: 'TransactionVerificationState.PENDING_VERIFICATION',
  VERIFIED: 'TransactionVerificationState.VERIFIED',
  REJECTED: 'TransactionVerificationState.REJECTED',
};

export type AccountTransactionVerificationState =
  (typeof ACCOUNT_TRANSACTION_VERIFICATION_STATE)[keyof typeof ACCOUNT_TRANSACTION_VERIFICATION_STATE];
